import { useState, type FormEvent } from 'react';

const MAX_PER_VISIT = 3;

/** Homepage form: players suggest a game. Only the short idea is sent; ideas land on the owner's dashboard. */
export function SuggestGame() {
  const [idea, setIdea] = useState('');
  const [state, setState] = useState<'idle' | 'sending' | 'sent' | 'error' | 'limit'>('idle');

  async function send(e: FormEvent) {
    e.preventDefault();
    let count = 0;
    try {
      count = Number(sessionStorage.getItem('sf:suggested') ?? 0);
    } catch {
      /* storage blocked: no limit */
    }
    if (count >= MAX_PER_VISIT) {
      setState('limit');
      return;
    }
    setState('sending');
    try {
      const r = await fetch('/api/suggest', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ idea }) });
      if (!r.ok) throw new Error(String(r.status));
      try {
        sessionStorage.setItem('sf:suggested', String(count + 1));
      } catch {
        /* ignore */
      }
      setIdea('');
      setState('sent');
    } catch {
      setState('error');
    }
  }

  return (
    <section className="band band--suggest" aria-labelledby="suggest-h">
      <form className="suggest" onSubmit={send}>
        <h2 id="suggest-h">
          <span aria-hidden="true">💡 </span>Suggest a Game
        </h2>
        <p className="suggest__lead">What should we make next? We read every idea.</p>
        <div className="suggest__row">
          <label className="suggest__field suggest__field--grow">
            <span>Your idea</span>
            <input
              value={idea}
              onChange={(e) => {
                setIdea(e.target.value);
                if (state !== 'sending') setState('idle');
              }}
              maxLength={80}
              minLength={3}
              required
              placeholder="e.g. a penguin racing game on ice"
            />
          </label>
          <button type="submit" className="suggest__send" disabled={state === 'sending'}>
            {state === 'sending' ? 'Sending…' : 'Send idea'}
          </button>
        </div>
        <p className="suggest__note">Please don’t include your name, email or anything personal.</p>
        <p className="suggest__status" role="status">
          {state === 'sent' && 'Thanks! Your idea was sent. 🎉'}
          {state === 'error' && 'That didn’t send. Ideas can’t include emails, links or phone numbers. Try again!'}
          {state === 'limit' && 'Thanks for all your ideas! You can send more next time you visit.'}
        </p>
      </form>
    </section>
  );
}
